import { Children, ReactElement, cloneElement } from 'react';
import styles from '../styles.module.scss';
import { isReactElementWithProps } from 'components/types';

interface ActionsProps {
  children: ReactElement | ReactElement[];
}

const Actions = ({ children }: ActionsProps) => (
  <div className={styles.actions}>
    {Children.map(children, (child) => {
      if (isReactElementWithProps(child)) {
        return cloneElement(child, {
          ...child.props,
          className: child.props.className,
        });
      }
    })}
  </div>
);

export default Actions;
